import preImage from './preImage.vue'

let $vm:any

export default {
  install(Vue:any) {

    if (!$vm) {
      const imagePlugin = Vue.extend(preImage)

      $vm = new imagePlugin({
        el: document.createElement('div')
      })

      document.body.appendChild($vm.$el)
    }

    Vue.prototype.$showImage = $vm.showImage

  }
}
